import { CostCalculation } from '@forms/CostCalculation'

import { Challenges } from './Challenges'
import { Client } from './Client'
import { Development } from './Development'
import { Header } from './Header'
import { MarketAnalysis } from './MarketAnalysis'
import { Result } from './Result'
import { Wrapper } from './styles'
import { Team } from './Team'

export function SightseeingAndTourBookingApp() {
  return (
    <Wrapper>
      <Header />
      <MarketAnalysis />
      <Client />
      <Challenges />
      <Team />
      <Development />
      <Result />
      <CostCalculation />
    </Wrapper>
  )
}
